/**
 * An owner with both a builder site and a card site gets the builder at `/`. Opening the card
 * dashboard (`/?view=card`) switches `/` to the card dashboard for the rest of this tab's session, so
 * the card editor's own links back to `/` (after saving a card, Back, and so on) don't bounce them
 * into the builder. Opening the builder switches it back.
 *
 * Kept in memory for in-app navigation and in sessionStorage for reloads; storage may be blocked,
 * in which case the choice lasts until the next full page load.
 */
const KEY = "stackje:card-site-view";
let chosen = false;

export function chooseCardSite(): void {
  chosen = true;
  try { sessionStorage.setItem(KEY, "1"); } catch { /* memory still holds it */ }
}

export function chooseBuilder(): void {
  chosen = false;
  try { sessionStorage.removeItem(KEY); } catch { /* nothing stored */ }
}

export function cardSiteChosen(): boolean {
  if (chosen) return true;
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}

/** Where the builder's "Your card site" link goes. */
export const CARD_SITE_HREF = "/?view=card";
